/* Mänresa engraving: native Shopify rebuild of the Webflow engraving popup.
   Logo upload (line item file property), message, drag-to-position + scale,
   generated proof image, multipart POST to /cart/add when a file is attached. */
(function () {
  'use strict';
  const popup = document.querySelector('[data-engraving-popup]');
  if (!popup) return;
  const finalWrap = document.querySelector('[data-engrave="final-preview-wrap"]');
  const formId = popup.querySelector('[data-engrave-file]').getAttribute('form');
  const form = document.getElementById(formId);
  if (!form) return;
  document.body.appendChild(popup); // escape transformed ancestors so position:fixed works

  const $ = (s, r = popup) => r.querySelector(s);
  const boards = JSON.parse((document.querySelector('[data-engrave-boards]') || {}).textContent || '[]');
  const boardImg = $('[data-engrave="selected-board-image"]');
  const imageWrap = $('.engrave_popup_image_wrap');
  const logoWrap = $('[data-engrave="dropzone-logo-wrap"]');
  const logoImg = $('[data-engrave="dropzone-image"]');
  const msgWrap = $('[data-engrave="dropzone-message-wrap"]');
  const msgText = $('[data-engrave="dropzone-text"]');
  const logoRadio = $('#Logo'), messageRadio = $('#Message');
  const logoInputWrap = $('[data-engrave="logo-wrap"]');
  const messageInputWrap = $('.upload_message_wrap');
  const fileInput = $('[data-engrave-file]');
  const pickBtn = $('[data-engrave-pick]');
  const fileLabel = $('[data-engrave-filename]');
  const scaleWrap = $('[data-engrave="scale-wrap"]');
  const scaleInput = $('[data-engrave-scale]');
  const textScaleInput = $('[data-engrave-text-scale]');
  const previewWrap = $('[data-engrave="logo-preview-wrap"]');
  const previewImg = $('[data-engrave="logo-preview-image"]');
  const messageInput = $('#engraving-message');
  const messageCount = $('[data-engraving-message-count]');
  const confirmBtn = $('[data-engraving-confirm]');
  const confirmWrap = $('.engrave_popup_btn .btn_main_wrap');
  const helper = $('.engrave_popup_visual_text');
  const props = {};
  document.querySelectorAll('[data-engrave-props] [data-prop]').forEach(el => (props[el.dataset.prop] = el));

  const state = { type: 'Logo', logoUrl: '', fileName: '', message: '', confirmed: false, x: null, y: null, scale: 100, tscale: 100, baseW: 0, mx: null, my: null };
  /* ---------- center snap guides (no visible boundary; engraving stays inside the board photo) ---------- */
  // Message stays within the board area of the product photo (% of photo; boards sit inside a margin of background)
  // Design may sit anywhere on the proof image; clamp only to the image edges (0-100%) so it is never clipped
  const MSG_BOX = { l: 0, r: 100, t: 0, b: 100 };
  const SAFE = 0;                  // clamp to photo edges
  const SNAP_PX = 6;               // minimum snap distance in px
  const SNAP_PCT = 3;              // snap to center within this % of the board
  const guides = document.createElement('div');
  guides.className = 'engrave_guides';
  guides.innerHTML = '<div class="engrave_guide is-v" data-engrave="guide-v"></div><div class="engrave_guide is-h" data-engrave="guide-h"></div>';
  imageWrap.appendChild(guides);
  const guideV = guides.querySelector('.is-v'), guideH = guides.querySelector('.is-h');
  function showGuides(sx, sy, on) {
    guides.classList.toggle('is-active', !!on);
    guideV.classList.toggle('is-snapped', !!sx); guideH.classList.toggle('is-snapped', !!sy);
  }
  const norm = v => String(v || '').trim().toLowerCase();

  function engravingSelect() {
    return Array.from(form.querySelectorAll('select')).find(s => /engraving/i.test(s.name) ||
      Array.from(s.options).some(o => norm(o.value) === 'with engraving'));
  }
  function boardSelect() { return Array.from(form.querySelectorAll('select')).find(s => /options\[board\]/i.test(s.name)); }
  function enabled() { const s = engravingSelect(); if (!s) return true; const v = norm(s.value); return v.includes('engraving') && v !== 'without engraving'; }
  function currentBoard() {
    const bs = boardSelect();
    if (bs) { const b = boards.find(b => norm(b.option) === norm(bs.value)) || boards.find(b => norm(bs.value).includes(norm(b.option))); if (b) return b; }
    return boards[0] || { option: '', image: boardImg.src };
  }
  // Per-board laser look, sampled from real engraved MANRESA boards: solid toasted ink, wood grain shows through (multiply),
  // crisp edges only (no blur). Walnut: near-black at full opacity + crisp 1px light cut edge (bottom/right).
  const LOOKS = {
    walnut: { ink: '#120604', blend: 'normal', alpha: 1, edge: 'rgba(214,168,128,.55)' },
    cherry: { ink: '#5A1C02', blend: 'normal', alpha: 1, edge: 'rgba(255,196,150,.6)' },
    maple:  { ink: '#9A5A28', blend: 'normal', alpha: 1, edge: 'rgba(252,226,190,.7)' },
    other:  { ink: '#331005', blend: 'multiply', alpha: 0.9, edge: '' }
  };
  const boardKey = b => { const k = String((b && b.option) || '') + ' ' + String((b && b.image) || ''); return /walnut/i.test(k) ? 'walnut' : /cherry/i.test(k) ? 'cherry' : /maple/i.test(k) ? 'maple' : 'other'; };
  const look = () => LOOKS[imageWrap.dataset.engrBoard] || LOOKS.other;
  // Logo -> solid ink silhouette (dark/opaque pixels become ink; white or transparent background drops out). Hard threshold keeps edges crisp.
  function inkCanvas(img, color, maxW) {
    const k = Math.min(1, (maxW || 1600) / (img.naturalWidth || 1)), w = Math.max(1, Math.round((img.naturalWidth || 300) * k)), h = Math.max(1, Math.round((img.naturalHeight || 300) * k));
    const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    const d = x.getImageData(0, 0, w, h), p = d.data, m = /^#(..)(..)(..)$/.exec(color) || [0, '33', '10', '05'];
    const R = parseInt(m[1], 16), G = parseInt(m[2], 16), B = parseInt(m[3], 16);
    for (let i = 0; i < p.length; i += 4) {
      const lum = (0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]) / 255;
      const a = (p[i + 3] / 255) * Math.min(1, Math.max(0, (0.82 - lum) / 0.12));
      p[i] = R; p[i + 1] = G; p[i + 2] = B; p[i + 3] = Math.round(a * 255);
    }
    x.putImageData(d, 0, 0); return c;
  }
  let tintTok = 0;
  function tintLogo() {
    if (!state.logoUrl) return; const t = ++tintTok, L = look();
    loadImg(state.logoUrl).then(i => { if (t !== tintTok) return; try { logoImg.src = inkCanvas(i, L.ink).toDataURL('image/png'); } catch (e) { logoImg.src = state.logoUrl; } }).catch(() => {});
  }
  function applyLook() {
    const L = look(), st = imageWrap.style;
    st.setProperty('--engr-ink', L.ink); st.setProperty('--engr-blend', L.blend); st.setProperty('--engr-alpha', String(L.alpha));
    st.setProperty('--engr-edge-ts', L.edge ? `1px 1px 0 ${L.edge}` : 'none');
    st.setProperty('--engr-edge-ds', L.edge ? `drop-shadow(1px 1px 0 ${L.edge})` : 'none');
    tintLogo();
  }
  function syncBoard() { const b = currentBoard(); const key = boardKey(b); const changed = imageWrap.dataset.engrBoard !== key; imageWrap.dataset.engrBoard = key; if (changed) applyLook(); if (b.image && boardImg.getAttribute('src') !== b.image) boardImg.src = b.image; try { if (state.message && msgWrap.style.display !== 'none') placeMessage(false); } catch (e) {} }

  /* ---------- popup ---------- */
  function openPopup() {
    syncBoard();
    popup.setAttribute('data-visible', 'true'); popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll'); document.body.classList.add('no-scroll');
    syncMode(false);
    requestAnimationFrame(() => placeLogo(false));
  }
  function closePopup() {
    popup.setAttribute('data-visible', 'false'); popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll'); document.body.classList.remove('no-scroll');
  }
  function setWithout() {
    const s = engravingSelect(); if (!s) return closePopup();
    const w = Array.from(s.options).find(o => norm(o.value) === 'without engraving');
    closePopup();
    if (w && s.value !== w.value) { s.value = w.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function cancel() { state.confirmed ? closePopup() : setWithout(); }

  /* ---------- mode ---------- */
  const show = (el, d = 'flex') => el && (el.style.display = d);
  const hide = el => el && (el.style.display = 'none');
  function setMode(type, invalidate = true) {
    state.type = type;
    const isLogo = type === 'Logo';
    logoRadio.checked = isLogo; messageRadio.checked = !isLogo;
    popup.setAttribute('data-engraving-type', isLogo ? 'logo' : 'message');
    isLogo ? show(logoInputWrap) : hide(logoInputWrap);
    isLogo ? hide(messageInputWrap) : show(messageInputWrap);
    isLogo && state.logoUrl ? show(logoWrap) : hide(logoWrap);
    isLogo && state.logoUrl ? show(scaleWrap) : hide(scaleWrap);
    isLogo ? hide(msgWrap) : show(msgWrap);
    helper.textContent = isLogo
      ? (state.logoUrl ? 'Drag your uploaded logo to reposition it within the marked engraving zone.' : 'Upload your logo to preview it in the engraving area.')
      : 'Enter your message to preview the engraving on the product.';
    if (invalidate) state.confirmed = false;
    updateMessage(false); updateConfirm();
    if (popup.dataset.visible === 'true') requestAnimationFrame(() => placeLogo(false));
  }
  function syncMode(inv = true) { setMode(messageRadio.checked ? 'Message' : 'Logo', inv); }

  function updateMessage(inv = true) {
    let v = (messageInput.value || '').substring(0, 30);
    if (messageInput.value !== v) messageInput.value = v;
    state.message = v;
    msgText.textContent = v || 'Your message';
    messageCount.textContent = v.length + '/30';
    if (state.type === 'Message') { if (state.mx != null) placeMessage(false); else applyTextScale(); }
    if (inv && state.type === 'Message') state.confirmed = false;
    updateConfirm();
  }
  function valid() { return state.type === 'Logo' ? !!state.logoUrl : !!state.message.trim(); }
  function updateConfirm() {
    const ok = valid(); confirmBtn.disabled = !ok;
    confirmBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    confirmWrap && confirmWrap.setAttribute('data-state', ok ? 'enabled' : 'disabled');
  }

  /* ---------- file ---------- */
  pickBtn.addEventListener('click', () => { fileInput.disabled = false; fileInput.click(); });
  fileInput.addEventListener('change', () => {
    const f = fileInput.files && fileInput.files[0];
    if (!f) return;
    if (!/^image\/(png|jpeg|webp|svg\+xml)$/.test(f.type)) { alert('Please choose a PNG, SVG, JPG or WEBP file.'); fileInput.value = ''; return; }
    if (f.size > 20 * 1024 * 1024) { alert('Logo files must be under 20 MB.'); fileInput.value = ''; return; }
    if (state.logoUrl) URL.revokeObjectURL(state.logoUrl);
    state.logoUrl = URL.createObjectURL(f); state.fileName = f.name;
    fileLabel.textContent = f.name;
    logoImg.src = state.logoUrl; previewImg.src = state.logoUrl;
    tintLogo();
    logoWrap.setAttribute('data-state', 'has-file'); previewWrap && previewWrap.setAttribute('data-state', 'has-file');
    state.x = state.y = null; state.scale = 100; scaleInput.value = 100; if (typeof syncLogoSlider === 'function') syncLogoSlider();
    state.confirmed = false;
    syncMode(true);
    requestAnimationFrame(() => placeLogo(false));
  });

  /* ---------- drag + scale (positions stored as % of the board image) ---------- */
  function clampSnap(x, y, wPct, hPct, W, H, snap) {
    // Anywhere on the visible image: the element's center may reach any edge/corner (0-100%), so its edges can go flush with
    // (or past) the image edges. The overflow is clipped in the preview and by the proof canvas, which maps 1:1 to the visible area.
    x = Math.min(100, Math.max(0, x));
    y = Math.min(100, Math.max(0, y));
    let sx = false, sy = false;
    if (snap) {
      if (Math.abs(x - 50) * W / 100 <= Math.max(SNAP_PX, W * SNAP_PCT / 100)) { x = 50; sx = true; }
      if (Math.abs(y - 50) * H / 100 <= Math.max(SNAP_PX, H * SNAP_PCT / 100)) { y = 50; sy = true; }
    }
    return { x, y, sx, sy };
  }
  function placeLogo(snap) {
    if (!imageWrap.offsetWidth) return;
    if (state.type === 'Message') return placeMessage(snap);
    if (!state.logoUrl) return;
    const W = imageWrap.clientWidth, H = imageWrap.clientHeight;
    if (!state.baseW) { logoWrap.style.width = ''; state.baseW = logoWrap.offsetWidth / W * 100 || 14; }
    let w = state.baseW * state.scale / 100;
    w = Math.min(w, 100 - 2 * SAFE);
    logoWrap.style.width = w + '%';
    const hPct = Math.min(logoWrap.offsetHeight / H * 100, 100 - 2 * SAFE);
    if (state.x == null) { // default = Webflow engraving zone (inset 63% auto auto 74%)
      state.x = 74 + state.baseW / 2; state.y = 63 + hPct / 2;
    }
    const r = clampSnap(state.x, state.y, w, hPct, W, H, snap);
    state.x = r.x; state.y = r.y; showGuides(r.sx, r.sy, snap);
    Object.assign(logoWrap.style, { position: 'absolute', inset: 'auto', left: (state.x - w / 2) + '%', top: (state.y - hPct / 2) + '%' });
  }
  function applyTextScale() {
    if (!msgText) return;
    msgText.style.fontSize = '';
    if (state.tscale === 100) return;
    const base = parseFloat(getComputedStyle(msgText).fontSize) || 14;
    let fs = base * state.tscale / 100;
    msgText.style.fontSize = fs + 'px';
    fitMessage(fs);
  }
  // Split the rendered message into its visual lines (wraps only at spaces).
  function messageLines() {
    const node = msgText.firstChild; if (!node || node.nodeType !== 3) return [];
    const txt = node.textContent, rg = document.createRange(), lines = [];
    let cur = null;
    for (let i = 0; i < txt.length; i++) {
      rg.setStart(node, i); rg.setEnd(node, i + 1);
      const rc = rg.getClientRects()[0]; if (!rc) continue;
      if (!cur || rc.top > cur.top + cur.h * 0.5) { cur = { s: i, e: i + 1, top: rc.top, h: rc.height, l: rc.left, r: rc.right }; lines.push(cur); }
      else { cur.e = i + 1; cur.l = Math.min(cur.l, rc.left); cur.r = Math.max(cur.r, rc.right); cur.h = Math.max(cur.h, rc.height); }
    }
    return lines.map(L => ({ text: txt.slice(L.s, L.e).trim(), left: L.l, right: L.r, top: L.top, height: L.h })).filter(L => L.text);
  }
  // Shrink only as much as needed so the message fits on at most 2 lines inside the board.
  function fitMessage(fs) {
    const W = imageWrap.clientWidth, H = imageWrap.clientHeight; if (!W || msgWrap.style.display === 'none') return;
    for (let n = 0; n < 40 && fs > 6; n++) {
      const mr = msgWrap.getBoundingClientRect(), lines = messageLines();
      const fits = lines.length <= 2 && mr.width <= W * (MSG_BOX.r - MSG_BOX.l) / 100 + 0.5 && mr.height <= H * (MSG_BOX.b - MSG_BOX.t) / 100 && msgText.scrollWidth <= msgWrap.clientWidth + 1;
      if (fits) break;
      fs *= 0.94; msgText.style.fontSize = fs + 'px';
    }
  }
  function placeMessage(snap) {
    applyTextScale();
    const W = imageWrap.clientWidth, H = imageWrap.clientHeight;
    if (!W || msgWrap.style.display === 'none') return;
    const wr = imageWrap.getBoundingClientRect(), mr = msgWrap.getBoundingClientRect();
    const wPct = mr.width / W * 100, hPct = mr.height / H * 100;
    if (state.mx == null) { state.mx = (mr.left - wr.left + mr.width / 2) / W * 100; state.my = (mr.top - wr.top + mr.height / 2) / H * 100; }
    const r = clampSnap(state.mx, state.my, wPct, hPct, W, H, snap);
    // keep the whole message box on the board
    r.x = Math.min(MSG_BOX.r - wPct / 2, Math.max(MSG_BOX.l + wPct / 2, r.x)); r.y = Math.min(MSG_BOX.b - hPct / 2, Math.max(MSG_BOX.t + hPct / 2, r.y));
    if (wPct > MSG_BOX.r - MSG_BOX.l) r.x = (MSG_BOX.l + MSG_BOX.r) / 2; if (hPct > MSG_BOX.b - MSG_BOX.t) r.y = (MSG_BOX.t + MSG_BOX.b) / 2;
    state.mx = r.x; state.my = r.y; showGuides(r.sx, r.sy, snap);
    Object.assign(msgWrap.style, { position: 'absolute', inset: 'auto', left: state.mx + '%', top: state.my + '%', transform: 'translate(-50%,-50%)' });
  }
  let drag = null, pinching = false;
  function bindDrag(el, isLogo) {
    const gx = () => isLogo ? state.x : state.mx, gy = () => isLogo ? state.y : state.my;
    const sxy = (x, y) => { if (isLogo) { state.x = x; state.y = y; } else { state.mx = x; state.my = y; } };
    el.addEventListener('pointerdown', e => {
      e.preventDefault(); el.setPointerCapture(e.pointerId); el.classList.add('is-dragging');
      drag = { sx: e.clientX, sy: e.clientY, x: gx(), y: gy() };
      placeLogo(true);
    });
    el.addEventListener('pointermove', e => {
      if (!drag || pinching) return;
      const r = imageWrap.getBoundingClientRect();
      sxy(drag.x + (e.clientX - drag.sx) / r.width * 100, drag.y + (e.clientY - drag.sy) / r.height * 100);
      state.confirmed = false; placeLogo(true);
    });
    const endDrag = () => { drag = null; el.classList.remove('is-dragging'); showGuides(false, false, false); };
    el.addEventListener('pointerup', endDrag); el.addEventListener('pointercancel', endDrag);
    el.addEventListener('keydown', e => {
      const d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (!d) return; e.preventDefault();
      if (gx() == null) placeLogo(false);
      let nx = gx() + d[0], ny = gy() + d[1];
      // keyboard snap: stepping across / next to the centre lands exactly on it
      if (d[0] && Math.abs(nx - 50) < 1) nx = 50; if (d[1] && Math.abs(ny - 50) < 1) ny = 50;
      sxy(nx, ny); state.confirmed = false; placeLogo(false);
      // arrow keys step 1%: keep exact centring only when landing on it; show guides briefly
      showGuides(Math.abs(gx() - 50) < 0.05, Math.abs(gy() - 50) < 0.05, true); clearTimeout(el._gt); el._gt = setTimeout(() => showGuides(false, false, false), 700);
    });
    el.addEventListener('blur', () => showGuides(false, false, false));
    // Touch: block page scroll/zoom while dragging, and keep dragging even if the browser cancels the pointer stream.
    let tdrag = null;
    el.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) return;
      const t = e.touches[0]; tdrag = { sx: t.clientX, sy: t.clientY, x: gx(), y: gy() };
      if (tdrag.x == null) { placeLogo(false); tdrag.x = gx(); tdrag.y = gy(); }
      e.preventDefault(); el.classList.add('is-dragging'); placeLogo(true);
    }, { passive: false });
    el.addEventListener('touchmove', e => {
      if (!tdrag) return; e.preventDefault();
      if (pinching) return;
      if (drag) return; // pointer events are handling it
      const t = e.touches[0], r = imageWrap.getBoundingClientRect();
      sxy(tdrag.x + (t.clientX - tdrag.sx) / r.width * 100, tdrag.y + (t.clientY - tdrag.sy) / r.height * 100);
      state.confirmed = false; placeLogo(true);
    }, { passive: false });
    const endTouch = () => { if (!tdrag) return; tdrag = null; if (!drag) { el.classList.remove('is-dragging'); showGuides(false, false, false); } };
    el.addEventListener('touchend', endTouch); el.addEventListener('touchcancel', endTouch);
    el.addEventListener('dragstart', e => e.preventDefault());
  }
  logoWrap.tabIndex = 0; logoWrap.setAttribute('aria-label', 'Logo position. Drag or use arrow keys to move.');
  bindDrag(logoWrap, true); bindDrag(msgWrap, false);
  msgWrap.tabIndex = 0; msgWrap.setAttribute('aria-label', 'Message position. Drag or use arrow keys to move.');
  if (textScaleInput) textScaleInput.addEventListener('input', () => { state.tscale = +textScaleInput.value; state.confirmed = false; placeMessage(false); updateConfirm(); });
  scaleInput.addEventListener('input', () => { state.scale = +scaleInput.value; state.confirmed = false; placeLogo(false); });
  window.addEventListener('resize', () => { if (popup.dataset.visible === 'true') placeLogo(false); });

  /* ---------- panel controls: value readouts + reset ---------- */
  function enhanceSlider(input, onReset) {
    if (!input) return null;
    const wrap = input.parentElement; wrap.classList.add('engr-slider');
    const lab = wrap.querySelector('label');
    const head = document.createElement('div'); head.className = 'engr-slider_head';
    if (lab) wrap.insertBefore(head, lab), head.appendChild(lab);
    const out = document.createElement('output'); out.className = 'engr-slider_val'; out.setAttribute('for', input.id); head.appendChild(out);
    const rs = document.createElement('button'); rs.type = 'button'; rs.className = 'engr-reset'; rs.textContent = 'Reset';
    rs.setAttribute('aria-label', 'Reset position and size'); head.appendChild(rs);
    const sync = () => { out.textContent = input.value + '%'; const p = (input.value - input.min) / (input.max - input.min) * 100; input.style.setProperty('--engr-fill', p + '%'); };
    const row = document.createElement('div'); row.className = 'engr-slider_row';
    const mk = (t, lbl, d) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'engr-step'; b.textContent = t; b.setAttribute('aria-label', lbl);
      b.addEventListener('click', () => { const v = Math.min(+input.max, Math.max(+input.min, +input.value + d * (+input.step || 5))); if (v === +input.value) return; input.value = v; input.dispatchEvent(new Event('input', { bubbles: true })); }); return b; };
    input.parentElement.insertBefore(row, input);
    row.appendChild(mk('\u2212', 'Decrease size', -1)); row.appendChild(input); row.appendChild(mk('+', 'Increase size', 1));
    input.addEventListener('input', sync); sync();
    rs.addEventListener('click', () => { onReset(); sync(); });
    return sync;
  }
  const syncLogoSlider = enhanceSlider(scaleInput, () => {
    state.scale = 100; scaleInput.value = 100; state.x = 50; state.y = 50; state.confirmed = false; placeLogo(false); updateConfirm();
  });
  const syncTextSlider = enhanceSlider(textScaleInput, () => {
    state.tscale = 100; textScaleInput.value = 100; state.mx = 50; state.my = 50; state.confirmed = false; placeMessage(false); updateConfirm();
  });
  /* ---------- mobile: sticky proof with the active size control docked under it ---------- */
  const mq = window.matchMedia('(max-width: 47.99em)');
  const visualWrap = imageWrap.parentElement;
  const dock = document.createElement('div'); dock.className = 'engr-dock';
  const helperEl = visualWrap.querySelector('.engrave_popup_visual_text');
  visualWrap.insertBefore(dock, helperEl ? helperEl.nextSibling : null);
  const homes = [scaleInput, textScaleInput].filter(Boolean).map(i => { const w = i.closest('.engr-slider'); return { w, parent: w.parentElement, next: w.nextSibling }; });
  function dockSlider() {
    const active = state.type === 'Logo' ? scaleInput : textScaleInput;
    homes.forEach(h => {
      const want = mq.matches && active && h.w.contains(active);
      if (want && h.w.parentElement !== dock) dock.appendChild(h.w);
      if (!want && h.w.parentElement === dock) h.parent.insertBefore(h.w, h.next && h.next.parentElement === h.parent ? h.next : null);
    });
    popup.classList.toggle('engr-mobile', mq.matches);
    let el = visualWrap.parentElement, bg = '';
    while (el && el !== document.body) { const c = getComputedStyle(el).backgroundColor; if (c && c !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(c)) { bg = c; break; } el = el.parentElement; }
    if (bg) visualWrap.style.setProperty('--engr-bg', bg);
  }
  (mq.addEventListener ? mq.addEventListener('change', dockSlider) : mq.addListener(dockSlider));
  [logoRadio, messageRadio].forEach(r => r.addEventListener('change', () => setTimeout(dockSlider, 0)));
  dockSlider();

  /* mobile: keep the close button pinned at the panel's top-right while it scrolls */
  const closeBtn = popup.querySelector('[data-engraving-close]');
  const panel = imageWrap.closest('.engrave_popup_content');
  function pinClose() {
    if (!closeBtn || !panel) return;
    if (!mq.matches || popup.dataset.visible !== 'true') { closeBtn.classList.remove('engr-close-pinned'); closeBtn.style.top = closeBtn.style.right = ''; return; }
    const r = panel.getBoundingClientRect();
    closeBtn.classList.add('engr-close-pinned');
    closeBtn.style.top = Math.max(4, r.top + 4) + 'px';
    closeBtn.style.right = Math.max(4, window.innerWidth - r.right + 4) + 'px';
  }
  if (panel && 'ResizeObserver' in window) new ResizeObserver(pinClose).observe(panel);
  window.addEventListener('resize', pinClose);
  new MutationObserver(() => requestAnimationFrame(pinClose)).observe(popup, { attributes: true, attributeFilter: ['data-visible'] });
  (mq.addEventListener ? mq.addEventListener('change', pinClose) : mq.addListener(pinClose));

  /* ---------- two-finger pinch on the proof resizes the active text/logo ---------- */
  let pinch = null;
  const tdist = t => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  imageWrap.addEventListener('touchstart', e => {
    if (e.touches.length !== 2) return;
    const input = state.type === 'Logo' ? (state.logoUrl ? scaleInput : null) : textScaleInput; if (!input) return;
    e.preventDefault(); pinching = true; drag = null;
    pinch = { d0: tdist(e.touches) || 1, v0: +input.value, input };
  }, { passive: false, capture: true });
  imageWrap.addEventListener('touchmove', e => {
    if (!pinch || e.touches.length < 2) return;
    e.preventDefault();
    const i = pinch.input, st = +i.step || 5;
    let v = Math.round(pinch.v0 * tdist(e.touches) / pinch.d0 / st) * st;
    v = Math.min(+i.max, Math.max(+i.min, v));
    if (v !== +i.value) { i.value = v; i.dispatchEvent(new Event('input', { bubbles: true })); }
  }, { passive: false, capture: true });
  const endPinch = e => { if (!pinch) return; if (e.touches.length < 2) { pinch = null; setTimeout(() => { pinching = false; }, 0); [logoWrap, msgWrap].forEach(el => el.classList.remove('is-dragging')); showGuides(false, false, false); } };
  imageWrap.addEventListener('touchend', endPinch, { capture: true }); imageWrap.addEventListener('touchcancel', endPinch, { capture: true });

  const radioList = logoRadio.closest('.upload_radio_field_list'); if (radioList) { radioList.classList.add('engr-seg'); radioList.setAttribute('role', 'radiogroup'); radioList.setAttribute('aria-label', 'Engraving type'); }

  /* ---------- proof image ---------- */
  function loadImg(src) { return new Promise((res, rej) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = rej; i.src = src; }); }
  async function makeProof() {
    try {
      const r = imageWrap.getBoundingClientRect();
      const W = 1200, H = Math.round(W * r.height / r.width);
      const c = document.createElement('canvas'); c.width = W; c.height = H; const ctx = c.getContext('2d');
      const b = await loadImg(boardImg.currentSrc || boardImg.src);
      const s = Math.max(W / b.naturalWidth, H / b.naturalHeight); // object-fit: cover
      ctx.drawImage(b, (W - b.naturalWidth * s) / 2, (H - b.naturalHeight * s) / 2, b.naturalWidth * s, b.naturalHeight * s);
      const L = look(), px = W / r.width; // 1 css px in proof pixels
      ctx.filter = 'none';
      const ink = (draw) => {
        if (L.edge) { ctx.save(); ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1; draw(L.edge, px, px); ctx.restore(); }
        ctx.save(); ctx.globalCompositeOperation = L.blend === 'normal' ? 'source-over' : L.blend; ctx.globalAlpha = L.alpha; draw(L.ink, 0, 0); ctx.restore();
      };
      if (state.type === 'Logo') {
        const lr = logoImg.getBoundingClientRect(), l = await loadImg(state.logoUrl); // image box (excludes wrap padding) = exactly what the preview shows
        const bw = lr.width / r.width * W, bh = lr.height / r.height * H;
        const k = Math.min(bw / (l.naturalWidth || bw), bh / (l.naturalHeight || bh));
        const lw = (l.naturalWidth || bw) * k, lh = (l.naturalHeight || bh) * k;
        const lx = (lr.left - r.left) / r.width * W + (bw - lw) / 2, ly = (lr.top - r.top) / r.height * H + (bh - lh) / 2;
        const rgbHex = c => { if (c[0] === '#') return c; const m = c.match(/[\d.]+/g) || [0, 0, 0]; return '#' + m.slice(0, 3).map(v => (+v).toString(16).padStart(2, '0')).join(''); };
        ink((col, dx, dy) => { const t = inkCanvas(l, rgbHex(col), Math.max(64, Math.round(lw))); if (col === L.edge) { ctx.globalAlpha = 0.55; } ctx.drawImage(t, lx + dx, ly + dy, lw, lh); });
      } else {
        const tr = msgText.getBoundingClientRect(), cs = getComputedStyle(msgText);
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = `${cs.fontWeight} ${parseFloat(cs.fontSize) * W / r.width}px ${cs.fontFamily}`;
        if ('letterSpacing' in ctx && cs.letterSpacing && cs.letterSpacing !== 'normal') ctx.letterSpacing = (parseFloat(cs.letterSpacing) * px) + 'px';
        const lines = messageLines();
        ink((col, dx, dy) => {
          ctx.fillStyle = col;
          if (!lines.length) ctx.fillText(state.message, (tr.left + tr.width / 2 - r.left) / r.width * W + dx, (tr.top + tr.height / 2 - r.top) / r.height * H + dy);
          lines.forEach(Ln => ctx.fillText(Ln.text, ((Ln.left + Ln.right) / 2 - r.left) / r.width * W + dx, (Ln.top + Ln.height / 2 - r.top) / r.height * H + dy));
        });
      }
      const blob = await new Promise(res => c.toBlob(res, 'image/jpeg', 0.85));
      return blob ? { blob, url: URL.createObjectURL(blob) } : null;
    } catch (e) { console.warn('[engraving] proof failed', e); return null; }
  }

  /* ---------- properties ---------- */
  function setProps(on) {
    const fields = ['type', 'message', 'board', 'placement', 'x', 'y', 'scale'];
    fields.forEach(k => { props[k].disabled = !on; if (!on) props[k].value = ''; });
    fileInput.disabled = !(on && state.type === 'Logo' && fileInput.files.length);
    if (!on || !props.proof.files.length) props.proof.disabled = true; else props.proof.disabled = false;
    if (!on) return;
    props.type.value = state.type;
    props.board.value = currentBoard().option || '';
    if (state.type === 'Logo') {
      props.message.value = ''; props.message.disabled = true;
      props.x.value = state.x.toFixed(1); props.y.value = state.y.toFixed(1); props.scale.value = state.scale;
      props.placement.value = `x ${state.x.toFixed(1)}%, y ${state.y.toFixed(1)}%, scale ${state.scale}%`;
    } else {
      props.message.value = state.message.trim();
      props.scale.value = state.tscale;
      if (state.mx != null) {
        props.x.value = state.mx.toFixed(1); props.y.value = state.my.toFixed(1);
        props.placement.value = `x ${state.mx.toFixed(1)}%, y ${state.my.toFixed(1)}%, scale ${state.tscale}%`;
      } else {
        props.x.value = ''; props.x.disabled = true; props.y.value = ''; props.y.disabled = true;
        props.placement.value = `scale ${state.tscale}%`;
      }
    }
  }
  function multipart(on) {
    if (on) { form.setAttribute('enctype', 'multipart/form-data'); form.removeAttribute('data-ajax-add'); }
    else { form.removeAttribute('enctype'); form.setAttribute('data-ajax-add', ''); }
  }

  async function confirm(e) {
    e && e.preventDefault();
    if (!valid()) { state.type === 'Logo' ? pickBtn.click() : messageInput.focus(); return; }
    confirmBtn.disabled = true;
    const proof = await makeProof();
    if (proof && window.DataTransfer) {
      try { const dt = new DataTransfer(); dt.items.add(new File([proof.blob], 'engraving-proof.jpg', { type: 'image/jpeg' })); props.proof.files = dt.files; } catch (_) {}
    }
    state.confirmed = true;
    setProps(true);
    multipart(state.type === 'Logo' || props.proof.files.length > 0);
    finalWrap.querySelector('[data-engrave="final-preview-image"]').src = proof ? proof.url : boardImg.src;
    finalWrap.querySelector('[data-engrave="final-text"]').textContent =
      state.type === 'Logo' ? 'Logo engraving: ' + state.fileName : 'Message engraving: “' + state.message.trim() + '”';
    finalWrap.setAttribute('data-visible', 'true');
    window.ManresaEngraving = { proofUrl: proof ? proof.url : '', type: state.type, message: state.message, x: state.type === 'Logo' ? state.x : state.mx, y: state.type === 'Logo' ? state.y : state.my, scale: state.type === 'Logo' ? state.scale : state.tscale, board: currentBoard().option };
    document.dispatchEvent(new CustomEvent('manresa:engraving-confirmed', { detail: window.ManresaEngraving }));
    updateConfirm(); closePopup();
  }
  function reset() {
    state.confirmed = false; finalWrap.setAttribute('data-visible', 'false');
    try { props.proof.value = ''; } catch (_) {}
    setProps(false); multipart(false);
  }
  function remove(e) {
    e && e.preventDefault();
    fileInput.value = ''; state.logoUrl = ''; state.fileName = ''; fileLabel.textContent = 'Select Logo File (PNG, SVG, JPG)';
    logoImg.removeAttribute('src'); logoWrap.removeAttribute('data-state'); previewWrap && previewWrap.removeAttribute('data-state');
    messageInput.value = ''; state.tscale = 100; if (textScaleInput) textScaleInput.value = 100; if (typeof syncTextSlider === 'function') syncTextSlider(); reset(); updateMessage(false); setWithout();
  }

  /* ---------- wiring ---------- */
  logoRadio.addEventListener('change', () => syncMode(true));
  messageRadio.addEventListener('change', () => syncMode(true));
  messageInput.addEventListener('input', () => updateMessage(true));
  confirmBtn.addEventListener('click', confirm);
  popup.querySelector('[data-engraving-close]').addEventListener('click', cancel);
  popup.querySelector('.engrave_popup_overlay').addEventListener('click', cancel);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.dataset.visible === 'true') cancel(); });
  finalWrap.querySelector('[data-engrave="final-preview-edit"]').addEventListener('click', () => { state.confirmed = false; openPopup(); });
  finalWrap.querySelector('[data-engrave="final-preview-remove"]').addEventListener('click', remove);

  form.addEventListener('change', e => {
    if (e.target.tagName !== 'SELECT') return;
    if (e.target === boardSelect()) { syncBoard(); if (state.confirmed) reset(); }
    if (enabled()) { if (!state.confirmed) setTimeout(() => enabled() && !state.confirmed && openPopup(), 100); }
    else reset();
  });

  // Capture phase: runs before theme.js's AJAX submit handler.
  document.addEventListener('submit', e => {
    if (e.target !== form) return;
    if (!enabled()) { reset(); return; }
    if (!state.confirmed || !valid()) { e.preventDefault(); e.stopImmediatePropagation(); openPopup(); return; }
    setProps(true);
    multipart(state.type === 'Logo' || props.proof.files.length > 0); // file attached => native multipart POST to /cart/add
  }, true);

  setProps(false); multipart(false); syncMode(false); updateMessage(false);
  if (enabled() && engravingSelect()) openPopup();
})();
